import { useState } from "react"
import Aside from "../../../components/Aside"
import Footer from "../../../components/Footer"
import Header from "../../../components/Header"
import ConversationsTab from "./ConversationsTab"
import { useTranslation } from "react-i18next"
enum TABS {
    CONVERSATIONS,
    KPIS,
}

function ReportChatbotPage() {

    const { t } = useTranslation();

    const [currentTab, setCurrentTab] = useState(TABS.CONVERSATIONS)
    
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page">{t("reports.reports-title")}</li>
                                        <li className="breadcrumb-item active" aria-current="page">Chatbot</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-grid-1x2 nav-icon"></i> {t("reports.reports-title")} - {t("reports.chatbot.chatbot-title")}</h1>
                            </div>
                        </div>
                    </div>

                    {/* <div className="js-nav-scroller hs-nav-scroller-horizontal mb-5">
                        <ul className="nav nav-tabs align-items-center">
                            <li className="nav-item">
                                <span className={'nav-link cursor-pointer ' + (currentTab === TABS.CONVERSATIONS ? 'active' : '')} onClick={() => setCurrentTab(TABS.CONVERSATIONS)}>Conversaciones</span>
                            </li>
                            <li className="nav-item">
                                <span className={'nav-link cursor-pointer ' + (currentTab === TABS.KPIS ? 'active' : '')} onClick={() => setCurrentTab(TABS.KPIS)} >KPIs</span>
                            </li>
                        </ul>
                    </div> */}


                    <ConversationsTab show={currentTab === TABS.CONVERSATIONS} />

                </div>
                <Footer />
            </main>
        </>
    )
}
export default ReportChatbotPage